import {Component, inject} from '@angular/core';
import {IonicModule, ModalController} from "@ionic/angular";
import {SolInputComponent} from "../../../common/components/forms/sol-input/sol-input.component";
import {INPUT_TYPE} from "../../../common/components/forms/sol-input/sol-input.enums";
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'sol-crm-input',
  standalone: true,
  imports: [
    IonicModule,
    SolInputComponent,
    FormsModule,
    TranslateModule
  ],
  template: `
    <ion-content>
      <ion-row>
        <ion-col>
          <sol-input
            [inputType]="inputType.TEXT"
            [clearInput]="true"
            [placeHolder]="'SETTINGS.CRM.enterToken' | translate"
            [editMode]="true"
            [fullWidth]="true"
            [label]="'SETTINGS.CRM.accessToken' | translate"
            [(ngModel)]="inputVal"
          />
          <ion-button
            expand="block"
            color="secondary"
            (click)="saveAndDismiss()">
            {{'COMMON.connect' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-content>
  `,
  styles: `
    ion-content {
      --ion-background-color: #F7F7F7;
    }
  `,
})
export class CRMInputComponent {
  protected readonly inputType = INPUT_TYPE;
  inputVal: string | undefined;
  private modalCtrl = inject(ModalController);

  async saveAndDismiss() {
    await this.modalCtrl.dismiss({ data: this.inputVal });
  }
}
